import { API, graphqlOperation } from "aws-amplify";
import { createGroupLf, deleteGroupLf, updateGroupLf } from "graphql/mutations";
import { getGroup, listGroups } from "graphql/queries";

import {
  GetGroupQuery,
  Group,
  GroupLfInput,
  ListGroupsQuery,
  Response,
  UpdateGroupInput,
} from "types/graphqlapi";

export const getGroupQuery = async (id: string): Promise<Group | undefined> => {
  try {
    const result = (await API.graphql(
      graphqlOperation(getGroup, {
        id,
      })
    )) as {
      data: GetGroupQuery;
    };
    const group = result.data.getGroup;
    if (!group) throw new Error("getGroup error");
    return group;
  } catch (e) {
    console.error(e);
    throw e;
  }
};

export const listGroupsQuery = async (): Promise<Group[] | undefined> => {
  try {
    const result = (await API.graphql(
      graphqlOperation(listGroups, { limit: 10000 })
    )) as {
      data: ListGroupsQuery;
    };

    // 削除データの排除
    const list = result?.data?.listGroups?.items as Group[];
    // createAtの昇順でソート
    list.sort((a, b) => {
      if (a.createdAt < b.createdAt) return -1;
      if (a.createdAt > b.createdAt) return 1;
      return 0;
    });

    return list;
  } catch (e) {
    // TODO エラーハンドリング
    console.error(e);
    throw e;
  }
};

export const createGroupMutation = async (
  input: GroupLfInput,
  id: string
): Promise<string | undefined> => {
  try {
    const result = (await API.graphql(
      graphqlOperation(createGroupLf, {
        input,
        id,
      })
    )) as {
      data: { createGroupLf: Response };
    };
    if (!result.data.createGroupLf.body) throw new Error("createGroup error");
    const resultJson = JSON.parse(result.data.createGroupLf.body);
    if (!resultJson.Result.id) throw resultJson;
    const groupId = resultJson.Result.id;
    return groupId;
  } catch (e) {
    console.error(e);
    throw e;
  }
};

export const updateGroupMutation = async (
  input: UpdateGroupInput,
  id: string
) => {
  try {
    return await API.graphql(graphqlOperation(updateGroupLf, { input, id }));
  } catch (e) {
    // TODO エラーハンドリング
    console.error(e);
    throw e;
  }
};

export const deleteGroupMutation = async (
  input: GroupLfInput,
  id: string
): Promise<string | undefined> => {
  try {
    const result = (await API.graphql(
      graphqlOperation(deleteGroupLf, {
        input,
        id,
      })
    )) as {
      data: { deleteGroupLf: Response };
    };
    if (!result.data.deleteGroupLf.body) throw new Error("deleteGroup error");
    const resultJson = JSON.parse(result.data.deleteGroupLf.body);
    if (!resultJson.Result.id) throw resultJson;
    const groupId = resultJson.Result.id;
    return groupId;
  } catch (e) {
    console.error(e);
    throw e;
  }
};
